export default __webpack_public_path__ + "static/media/WallenDiaz1-1ETHM.0bc12082.mp4";